/***
 * @file:
 * @author: haoxianhuan
 * @Date: 2021-10-19 10:53:32
 */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import monitor from '../monitor';

@Component({
  selector: 'dt-base-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.scss'],
})
export class BaseLayoutComponent implements OnInit, OnDestroy {
  @Input() set layouts(layoutData) {
    if (layoutData) {
      this.layoutData = layoutData.layouts || [];
      this.pageData = layoutData || {};
    }
  }
  @Input() templateOutlet: TemplateRef<any> | null;
  @Input() templateCardExtra: TemplateRef<any> | null;
  formRef: any;
  pageData = {};
  layoutData = [];
  formValue = {};
  @Input() validateForm: FormGroup; // ä¼ éè¿æ¥çformè¡¨å
  @Input() set sourceData(data: any) {
    if (data) {
      // this.data = data;
      const attachedPropertyMap = {};
      const pageData = this.pageData;
      // èªå®ä¹å­æ®µ
      if (Object.prototype.toString.call(data.attachedPropertyMap) === '[object Object]') {
        Object.keys(data.attachedPropertyMap).forEach((key) => {
          attachedPropertyMap['attachedPropertyMap.' + key] = data.attachedPropertyMap[key];
        });
      }
      Object.keys(pageData).forEach((key) => {
        if (pageData[key].bindKey) {
          if (pageData[key].type === 'baseForm') {
            const formConf = pageData[key].data;
            this.setAttachedProperty(formConf, pageData[key].bindKey, attachedPropertyMap, data);
          } else if (pageData[key].type === 'baseTable') {
            if (!data[pageData[key].bindKey]) {
              data[pageData[key].bindKey] = pageData[key].body || [{ list: [] }];
            } else {
              const tableList = data[pageData[key].bindKey];
              data[pageData[key].bindKey] = tableList.map((i) => {
                if (!Array.isArray(i.list)) {
                  return { list: i };
                }
                return i;
              });
            }
            if (attachedPropertyMap[pageData[key].bindKey]) {
              data[pageData[key].bindKey] = attachedPropertyMap[pageData[key].bindKey];
            }
          }
        }
      });
      this.data = data;
    }
  } // åå§æ°æ®
  data = {};
  checkboxValues = {};
  @Input() onBeforeUpload: any;
  // form
  @Input() vertical: boolean;
  // å±å¼æå 
  @Input() fold = true;
  @Input() gutter = 10; // nzGutter å±æ§
  @Input() offsetWidth: number;
  // æ¯å¦å±ç¤ºç¡®è®¤æé®ï¼æç´¢ï¼éç½®ãåæ¶ãç¡®å®ï¼
  @Input() showConfirmBtn = false;
  @Input() cardBordered = false;
  @Output() valueChange = new EventEmitter<any>();
  @Output() afterClick = new EventEmitter<any>();
  @Output() beforeClick = new EventEmitter<any>();
  @Output() itemClick = new EventEmitter<any>();

  @Output() formSearch = new EventEmitter<any>(); // æç´¢äºä»¶
  @Output() resetFormSearch = new EventEmitter<any>(); // éç½®äºä»¶
  @Output() valueChangeSelect = new EventEmitter<any>(); // å±æ§å¼ååæ¶çäºä»¶

  @Output() formConfirm = new EventEmitter<any>(); // å¼¹æ¡çç¡®è®¤äºä»¶
  @Output() customized = new EventEmitter<any>();
  @Output() blur = new EventEmitter<any>();
  @Output() keyup = new EventEmitter<any>();
  @Output() selectClick = new EventEmitter<any>();
  constructor() {}

  ngOnInit() {
    monitor.on('checkboxValues', (prop, bindKey, value) => {
      if (bindKey) {
        if (!this.checkboxValues[bindKey]) {
          this.checkboxValues[bindKey] = {};
        }
        this.checkboxValues[bindKey][prop] = value;
      } else {
        this.checkboxValues[prop] = value;
      }
    });
  }
  ngOnDestroy(): void {
    monitor.off('checkboxValues');
  }

  // éªè¯ææè¡¨å
  validate() {
    const validates: any[] = monitor.emit('form-validate');
    return !validates.some((i) => !i.validate);
  }
  setAttachedProperty(data: any[], bindkey, attachedPropertyMap, sourceData) {
    data.forEach((i) => {
      if (attachedPropertyMap.hasOwnProperty(i.prop)) {
        if (sourceData[bindkey]) {
          sourceData[bindkey][i.prop] = attachedPropertyMap[i.prop];
        }
      }
      if (Array.isArray(i.confList)) {
        this.setAttachedProperty(i.confList, bindkey, attachedPropertyMap, sourceData);
      }
    });
  }
  // è·åææè¡¨æ ¼è¡¨åæ°æ®
  getValue() {
    const values: any[] = monitor.emit('form-getValue');
    const attachedPropertyMap = {};
    const data = { ...this.data };
    values.forEach((form) => {
      if (form.bindKey) {
        if (!this.formValue[form.bindKey]) {
          this.formValue[form.bindKey] = data[form.bindKey] || {};
        }
        this.formValue[form.bindKey] = { ...this.formValue[form.bindKey], ...form.value };
        const formValue = {};
        // è¿æ»¤ attachedPropertyMap.xx æ¾å¥ attachedPropertyMap å¯¹è±¡
        Object.keys(this.formValue[form.bindKey]).forEach((key) => {
          if (/(attachedPropertyMap\.).+/.test(key)) {
            const attachedProperty = key.split('.')[1];
            attachedPropertyMap[attachedProperty] = this.formValue[form.bindKey][key];
          } else {
            formValue[key] = this.formValue[form.bindKey][key];
          }
        });
        Object.keys(this.checkboxValues).forEach((key) => {
          if (/(attachedPropertyMap\.).+/.test(key)) {
            const attachedProperty = key.split('.')[1];
            attachedPropertyMap[attachedProperty] = this.checkboxValues[key];
          } else {
            data[key] = this.checkboxValues[key];
          }
        });
        data[form.bindKey] = formValue;
      } else {
        this.data = { ...this.data, ...this.getAttachedProperty(form.value) };
      }
    });

    if (!data['attachedPropertyMap']) {
      data['attachedPropertyMap'] = {};
    }

    Object.keys(data).forEach((key) => {
      if (/(attachedPropertyMap\.).+/.test(key)) {
        const attachedProperty = key.split('.')[1];
        attachedPropertyMap[attachedProperty] = data[key];
        delete data[key];
      }
    });
    // å¨æå­æ®µ
    data['attachedPropertyMap'] = { ...data['attachedPropertyMap'], ...attachedPropertyMap };
    return data;
  }
  getAttachedProperty(data) {
    const formValue = {};
    // è¿æ»¤ attachedPropertyMap.xx æ¾å¥ attachedPropertyMap å¯¹è±¡
    Object.keys(data).forEach((key) => {
      if (/(attachedPropertyMap\.).+/.test(key)) {
        const attachedProperty = key.split('.')[1];
        formValue[attachedProperty] = data[key];
      } else {
        formValue[key] = this.formValue[key];
      }
    });
    return formValue;
  }
  // form event
  search(e, from) {
    this.formSearch.emit({ ...e, from });
  }
  formValueChange(e, from) {
    this.valueChange.emit({ ...e, from });
  }
  formValueChangeSelect(e, from) {
    this.valueChange.emit({ ...e, from });
  }
  formCustomized(e, from) {
    this.customized.emit({ ...e, from });
  }
  formBlur(e, from) {
    console.log(12222, e.value.target.value, { ...e, from });

    this.blur.emit({ ...e, from });
  }
  formKeyup(e, from) {
    this.keyup.emit({ ...e, from });
  }
  formSelectClick(e, from) {
    this.selectClick.emit({ ...e, from });
  }
  // tavle event
  tableAfterClick(e, table) {
    this.afterClick.emit({ ...e, table });
  }
  tableValueChange(e, table) {
    this.valueChange.emit({ ...e, table });
  }
  tableBeforeClick(e, table) {
    this.beforeClick.emit({ ...e, table });
  }
  tableItemClick(e, table) {
    this.itemClick.emit({ ...e, table });
  }
}
